export default __webpack_public_path__ + "static/network-options-image-dce1a8b23843ef7f9b968e8c02305e02.png";